import { CmtsAdminIdentityPage } from "../components/admin/index.js";
import { cmtsTenantAdminIdentityConfig } from "../config/adminIdentity.config.js";

export function CmtsTenantPage() {
  return <CmtsAdminIdentityPage config={cmtsTenantAdminIdentityConfig} />;
}

export default CmtsTenantPage;
